import "./BookDemo.module.css";
import Header from "@/reusable_sections/Header";
import DemoBookingForm from "./sections/DemoBookingForm";
import Footer from "@/reusable_sections/Footer";
export default function BookDemoPage() {
  return <div>
      <Header />
      <DemoBookingForm />
      <Footer />
    </div>;
}